import { tapResponse } from '@ngrx/operators';
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
  withProps,
} from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  withEntities,
} from '@ngrx/signals/entities';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap } from 'rxjs';
import { Injector } from '@angular/core';
import { IrisService } from '@shared/services/iris.service';

// Degree entity config
const degreeEntity = () =>
  entityConfig({
    collection: '_degrees',
    entity: type<string>(),
    selectId: (entity: string) => entity,
  });

/**
 * withDegreesEntities is a function that creates a signal store feature
 * for managing the degree entity slice. It provides an ability to plug and play
 * It uses the NgRx Signals library to create a reactive store feature.
 */
export const withDegreesEntities = (_injector: Injector) => {
  return signalStoreFeature(
    withProps((store) => ({
      store,
    })),
    withEntities(degreeEntity()),
    withMethods(({ store }) => {
      const _fetchDegrees = rxMethod<void>(
        pipe(
          switchMap(() => {
            const irisService = _injector.get(IrisService);
            return irisService.getDegreeList().pipe(
              tapResponse({
                error: (error: Error) =>
                  console.error('Error loading degrees:', error),
                finalize: () => patchState(store, { loading: false }),
                next: (response: string[]) => {
                  patchState(store, setAllEntities(response, degreeEntity()));
                },
              }),
            );
          }),
        ),
      );
      return {
        setDegrees: () => _fetchDegrees(),
      };
    }),
  );
};
